$(() => {
  const contentWrappers = $('.method-text__content');

  if (contentWrappers.length) {
    new HandshqApp.EditableContent(contentWrappers).setup();
  }
});
